// Single place the app talks to Claude.
//
// All requests go through YOUR server proxy (app/api/anthropic+api.ts), which
// holds the secret key server-side — so NO key ever ships in the app bundle.
// The proxy is deployed on EAS Hosting; EXPO_PUBLIC_API_BASE points the app at
// it. The Anthropic key lives only in the deployment's server env var.
const API_BASE = process.env.EXPO_PUBLIC_API_BASE;

/**
 * POST a Claude `/v1/messages` payload and return the parsed JSON response.
 * Routes through the server proxy. Throws on network failure / misconfig
 * (callers handle their own fallbacks).
 */
export async function callClaude(payload: Record<string, unknown>): Promise<any> {
  if (!API_BASE) {
    throw new Error('EXPO_PUBLIC_API_BASE is not set — cannot reach the Claude proxy.');
  }
  const res = await fetch(`${API_BASE}/api/anthropic`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  // Surface API rejections (oversized image, bad request, auth) as real errors
  // instead of returning an error body that callers mistake for "no response".
  if (!res.ok) {
    throw new Error(`Claude API ${res.status}: ${data?.error?.message ?? JSON.stringify(data)}`);
  }
  return data;
}
